import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Analisis`, method: 'GET', body: null})
}
